import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { SignInComponent } from '../../pages/sign-in/sign-in.component';
import { SignUpComponent } from '../../pages/sign-up/sign-up.component';

@Component({
  selector: 'app-account-dialog',
  templateUrl: './account-dialog.component.html',
  styleUrls: ['./account-dialog.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    CommonModule,
    SignInComponent,
    SignUpComponent,
  ],
})
export class AccountDialogComponent implements OnInit {
  @Input() nextPageRoute: string = 'account';
  @Input() idEvent: number | null = null;
  @Input() loginPage = true;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  changePage() {
    this.loginPage = !this.loginPage;
  }
}
